import { useContext, useEffect, useState } from 'react';
import { Box, Button, Stack, SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import { UserContext } from '../../components/shared/useUser';
import { useNavigate } from 'react-router-dom';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import CataloguesTab from './components/CataloguesTab';

const CataloguesPage = () => {
  const { t } = useTranslation('catalogues');
  const theme = useTheme();
  const navigate = useNavigate();

  const { hasPermissionTo } = useContext(UserContext);
  const [hasPermissionToCreateCatalogue, setHasPermissionToCreateCatalogue] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  useEffect(() => {
    setHasPermissionToCreateCatalogue(hasPermissionTo(['CatalogueCreate', 'ConfigurationAdmin']));
  }, [hasPermissionTo]);

  const handleCreateNew = () => {
    navigate('/catalogues/create');
  };

  const canViewCatalogues = hasPermissionTo(['CatalogueView', 'ConfigurationAdmin']);

  if (!canViewCatalogues) {
    return null;
  }

  return (
    <PageArea>
      <Stack
        width='100%'
        spacing={2}
        direction={isMobile ? 'column' : 'row'}
        sx={{
          justifyContent: 'space-between',
          mb: 4, // Add margin bottom for spacing
        }}
      >
        <Box width={isMobile ? '100%' : 'auto'}>
          <PageTitle>{t('management.pageTitle')}</PageTitle>
        </Box>

        {hasPermissionToCreateCatalogue && (
          <Box
            width={isMobile ? '100%' : 'auto'}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              variant="primary"
              size="lg"
              startIcon={<SvgIcon><Plus fill='white' /></SvgIcon>}
              onClick={handleCreateNew}
              sx={{
                mb: { xs: 4, md: 0 },
              }}
            >
              {t('management.createNew')}
            </Button>
          </Box>
        )}
      </Stack>
      
      <CataloguesTab onCreateNew={handleCreateNew} />
    </PageArea>
  );
};

export default CataloguesPage;
